import {Action} from "../../../action/action";
import type {CancelBookingAdminState} from "../cancelBookingAdminState";
import type {FeeSize} from "../cancelBookingAdminState.types";

export const SET_CANCELLATION_FEE_SIZE = "SET_CANCELLATION_FEE_SIZE";
export class SetCancellationFeeSize extends Action<typeof SET_CANCELLATION_FEE_SIZE, FeeSize> {
  readonly type = SET_CANCELLATION_FEE_SIZE;
  protected state: CancelBookingAdminState;

  constructor(state: CancelBookingAdminState, data?: FeeSize) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    if ([0, 50, 100].includes(this.data)) return true;
    return false;
  }

  public isDoable(): boolean {
    return true;
  }
}
